import { ReactElement, ReactNode } from 'react'
import { SnackbarKey, SnackbarProvider } from 'notistack'
import { useControlStore } from '@editorStores'
import ExpandableSnackbarContent from './ExpandableSnackbarContent'

interface Props {
  children: ReactNode
  action: (key: SnackbarKey) => ReactNode
}

const SnackbarProviderWithSceneAnchor = ({ children, action }: Props): ReactElement => {
  const snackbarAnchor = useControlStore(state => state.snackbarAnchorElement)

  return (
    <SnackbarProvider
      autoHideDuration={10000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      domRoot={snackbarAnchor ?? undefined}
      action={action}
      Components={{
        default: ExpandableSnackbarContent,
        error: ExpandableSnackbarContent,
        info: ExpandableSnackbarContent,
        success: ExpandableSnackbarContent,
        warning: ExpandableSnackbarContent,
      }}
    >
      {children}
    </SnackbarProvider>
  )
}

export default SnackbarProviderWithSceneAnchor
